import { Component, OnInit ,DoCheck} from '@angular/core';
import {Http,Headers,ResponseOptions} from "@angular/http";
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {Router} from "@angular/router";

import {Cookie} from "ng2-cookies/ng2-cookies";
import {HttpAddress} from "../../service/httpaddress";
@Component({
  selector: 'app-firstpage',
  templateUrl: './firstpage.component.html',
  styleUrls: ['./firstpage.component.css'],
})
export class FirstpageComponent implements OnInit{
  menu:any[] =  [
    {
      "tittle": "采购中心",
      "index":"2",
      "number": "0",
      "path": "servicepage/purchase",
      "mespath": "servicepage/message"
    },
    {
      "tittle": "合同中心",
      "number": "0",
      "index":"3",
      "path": "servicepage/contract",
      "mespath": "servicepage/message"
    },
    {
      "tittle": "统计查询",
      "index":"4",
      "number": "0",
      "path": "servicepage/statistics",
      "mespath": "servicepage/message"
    }
  ];
  flag:number = 0;
  is_mes:boolean=false;
  is_getmes:boolean = false;
  firminfor:boolean = false;
  mes_test:boolean;
  getmessage:string = null;
  is_invoice:boolean = true;
  token:string;
  username:string;
  listarr:any[] = [];
  listindex:number=0;
  swiperSlide:any;
  images
  private headers= new Headers({'Content-Type': 'application/json'});
  private options;
  private httpget = new HttpAddress();
  constructor(
      private router: Router,
      // private _coo:CookieService,
      private http:Http
  ) {
  }
  
  ngOnInit() {
    if(Cookie.get("usertoken")!=undefined){
      var $this = this;
    $this.username = Cookie.get("username");
    $this.token = Cookie.get("usertoken");
    }
    this.labelPlan();
    this.moveRight()
  }
  ngAfterViewInit(){}
  checkmes(){
    var $this = this;
    var infor =  Cookie.get("infor");
    if(infor =="notok"){
      $this.mes_test =  false;
    }else if(infor=="ok"){
      $this.mes_test = true;
    }else if(infor==undefined){
      $this.headers.delete("token");
      $this.headers.append("token",$this.token);
      $this.options = new ResponseOptions({headers:$this.headers});
      var json = {"username":$this.username};
      $this.http.post($this.httpget.checkinfor(),JSON.stringify(json),$this.options).subscribe(function (res) {
        if(res.json().code==2001){
          Cookie.set("infor","ok");
          $this.mes_test = true;
        }else{
          Cookie.set("infor","notok");
          $this.mes_test = false;
        }
      });
    }
  }
  //进入消息中心
  mesCenter(path){
    this.checkmes();
    if(this.mes_test == false){
      this.is_getmes = true;
    }else{
      this.is_getmes = false;
      Cookie.delete("userallsize");
      Cookie.set("userallsize","0");
      this.router.navigate([""+path+""]);
    }
  }
  //进入用户中心
  userCenter(path,a){
    this.checkmes();
    if(this.mes_test == false){
      this.is_getmes = true;
    }else {
      Cookie.delete("index");
      Cookie.set("index", a);
      this.router.navigate(["" + path + ""]);
    }
  }
  //获得信息
  getmesTip(){
    this.is_getmes = false;
    Cookie.delete("index");
    Cookie.set("index","1");
    this.router.navigate(['servicepage/firm']);
  //  this._coo.put("infor","notok");
  }
  //贴片列表
  labelPlan(){
    var $this = this;
    $this.http.get($this.httpget.labelplan()).subscribe(function (response) {
        $this.listarr=response.json().data;
        console.log($this.listarr)
    });
    this.images = $this.httpget.pictures()
    console.log(this.images)
  }
  showMsg(i){
      this.listindex=i+1;
      this.is_invoice = !this.is_invoice;
  }
  hideMsg(){
    this.is_invoice = !this.is_invoice;
  }
  moveRight(): void{
    let picS=document.getElementById("picScroll");
    let MyMar=setInterval(() => this.marQuee(picS), 10)
    picS.onmouseover=function() {clearInterval(MyMar)};
    var $this = this;
    picS.onmouseout=function() {
      MyMar=setInterval(() => $this.marQuee(picS), 10)
    };
  }
  marQuee(picS): void {
    if(picS.scrollLeft >=150){
      let item=this.listarr[0];
      this.listarr.splice(0, 1);
      this.listarr.push(item)
        picS.scrollLeft =0;
    }else{
      picS.scrollLeft++;
    }
  }
}


// WEBPACK FOOTER //
// ./src/mainpage/frontpage/firstpage.component.ts